// extracted by mini-css-extract-plugin
export default {"TagPreviewWrap":"TagPreviewWrap--7D8fP","TagPreview":"TagPreview--8yyv2","Tag":"Tag--+Kjbw","localTag":"localTag--saT3z"};